import { render } from "./UpdateDistributionModal.vue?vue&type=template&id=312088ec"
import script from "./UpdateDistributionModal.vue?vue&type=script&lang=js"
export * from "./UpdateDistributionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__